import { useCallback } from "react";

/**
 * Send a message to the parent container when embedded in an iframe
 */
export const useSendMessage = () => {
  const sendMessage = useCallback((message: any) => {
    window.parent.postMessage(message, "*");
  }, []);
  return sendMessage;
};
